import type { VFC } from 'react';
import { Col, Row } from 'antd';
import { RowGutter } from 'common/spacing';
import { StatTile } from 'components/enmon/card/StatTile';
import type { EntityStats } from '@enmon/commons/lib/enmon';
import { IncomeChart } from './charts/IncomeChart';
import { Icon } from '@/components/icon';

const STAT_TILE_CONFIG = {
  lg: 12,
  xl: 12,
  xxl: 8,
  md: 12,
  span: 24,
};

interface StatisticsProps {
  customers?: EntityStats;
  establishments?: EntityStats;
  metersOnline?: EntityStats;
  metersOffline?: EntityStats;
  isLoading: boolean;
}

export const Statistics: VFC<StatisticsProps> = ({
  customers = { count: 0 },
  establishments = { count: 0 },
  metersOnline = { count: 0 },
  metersOffline = { count: 0 },
  isLoading,
}) => (
  <Row align="middle" gutter={[RowGutter.Default, RowGutter.Default]}>
    <Col lg={{ span: 24 }} span={24} xl={{ span: 24 }} xxl={8}>
      <IncomeChart />
    </Col>
    <Col lg={{ span: 24 }} span={24} xl={{ span: 24 }} xxl={16}>
      <Row wrap gutter={[RowGutter.Default, RowGutter.Default]}>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="users" />}
            isLoading={isLoading}
            title="Customers"
            value={customers.count}
          />
        </Col>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="home" />}
            isLoading={isLoading}
            title="Establishments"
            value={establishments.count}
          />
        </Col>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="wifi" />}
            isLoading={isLoading}
            title="Meters online"
            value={metersOnline.count}
          />
        </Col>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="gauge" />}
            isLoading={isLoading}
            title="Meters offline"
            value={metersOffline.count}
          />
        </Col>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="textDocument" />}
            isLoading={false}
            title="Dummy invoices"
            value={Math.floor(Math.random() * 1000)}
          />
        </Col>
        <Col {...STAT_TILE_CONFIG}>
          <StatTile
            icon={<Icon iconString="eye" />}
            isLoading={false}
            title="Dummy predictions"
            value={Math.floor(Math.random() * 1000)}
          />
        </Col>
      </Row>
    </Col>
  </Row>
);
